import React from 'react';
import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import HekaosLogo from '../common/HekaosLogo.jsx';

const Header = ({ toggleLeftSidebar, toggleRightSidebar }) => (
  <header className="bg-surface backdrop-blur-sm border-b border-subtle sticky top-0 z-40">
    <div className="container mx-auto px-4 py-4 flex items-center justify-between">
      
      <div className="flex items-center gap-3">
        <button 
          onClick={toggleLeftSidebar} 
          className="lg:hidden accent-amber hover:text-primary transition-colors"
        >
          <Menu size={24} />
        </button>

        {/* 👇 Clickable Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <HekaosLogo />
          <h1 className="hekaos-title text-xl sm:text-2xl font-bold tracking-wide">HEKAOS</h1>
        </Link>
      </div>

      <button 
        onClick={toggleRightSidebar} 
        className="lg:hidden accent-amber hover:text-primary transition-colors"
      >
        <Menu size={24} />
      </button>

    </div>
  </header>
);

export default Header;
